import queryString from "query-string";
import { EngineEarsError } from "../../store/actions/errorStore";
import {
  makeBackendGetCallWithJsonResponse,
  makeBackendPostCallWithJsonResponse,
  makeBackendPutCallWithJsonResponse,
} from "../../store/utils/fetch";
import {
  FETCH_PRODUCT_TRANSACTION_DETAILS,
  FETCH_PURCHASED_PRODUCTS,
  PAY_PRODUCT_TRANSACTION,
  PRODUCT_TRANSACTION_API,
  PRODUCT_TRANSACTION_CHECKOUT_ROUTE,
  UPDATE_PRODUCT_TRANSACTION_API,
  UPDATE_PAY_WHAT_YOU_WANT_PRICE_API,
} from "../../store/utils/routes";
import { promiseEngineEarsHandler } from "../helpers";
import {
  ProductTransaction,
  ProductTransactionCreateArgs,
  ProductTransactionResponse,
  PurchasedProductTransactionOrderBy,
  PurchasedProductTransactionResponse,
  TransactionItemsGroupedByProduct,
} from "./models";
import { compile } from "path-to-regexp";

export const createProductTransaction = async (
  args: ProductTransactionCreateArgs,
) => {
  return await makeBackendPostCallWithJsonResponse<
    ProductTransactionResponse | EngineEarsError
  >(PRODUCT_TRANSACTION_CHECKOUT_ROUTE, args);
};

export const updateProductTransaction = async (transcationCode: string) => {
  const route = compile(UPDATE_PRODUCT_TRANSACTION_API)({
    transaction_code: transcationCode,
  });
  // Why is a put being called without a request body?
  return await makeBackendPutCallWithJsonResponse<
    ProductTransactionResponse | EngineEarsError
  >(route, {});
};

export const fetchProductTransaction = async (transactionCode: string) => {
  const updatedRoute = compile(PRODUCT_TRANSACTION_API)({
    transaction_code: transactionCode,
  });
  return await makeBackendGetCallWithJsonResponse<
    ProductTransactionResponse | EngineEarsError
  >(updatedRoute, "");
};

export const fetchProductTransactionDetails = async (
  transactionCode: string,
) => {
  const updatedRoute = compile(FETCH_PRODUCT_TRANSACTION_DETAILS)({
    transaction_code: transactionCode,
  });
  return await makeBackendGetCallWithJsonResponse<
    TransactionItemsGroupedByProduct[] | EngineEarsError
  >(updatedRoute, "");
};

interface markProductTransactionAsPaidPayloadProps {
  tax_calculation_id?: string;
  clothing_size?: string;
}

export const markProductTransactionAsPaid = async (
  transactionCode: string,
  payload: markProductTransactionAsPaidPayloadProps = {},
) => {
  const updatedRoute = compile(PAY_PRODUCT_TRANSACTION)({
    transaction_code: transactionCode,
  });
  return await makeBackendPostCallWithJsonResponse<
    ProductTransaction | EngineEarsError
  >(updatedRoute, payload);
};

export const fetchPurchasedProductTransactions = async (
  searchQuery: string,
  page: number,
  orderBy: PurchasedProductTransactionOrderBy,
) => {
  const params = queryString.stringify(
    {
      search_query: searchQuery,
      page,
      order_by: orderBy,
    },
    { skipEmptyString: true, skipNull: true },
  );
  return await makeBackendGetCallWithJsonResponse<
    PurchasedProductTransactionResponse | EngineEarsError
  >(FETCH_PURCHASED_PRODUCTS, `?${params}`);
};

export const updatePayWhatYouWantPrice = async (
  transactionCode: string,
  updatedPrice: number,
) => {
  const route = compile(UPDATE_PAY_WHAT_YOU_WANT_PRICE_API)({
    transaction_code: transactionCode,
  });

  return await makeBackendPostCallWithJsonResponse<
    TransactionItemsGroupedByProduct[]
  >(route, { updated_price: updatedPrice }).then(promiseEngineEarsHandler);
};
